import { useCallback, useRef, useState } from 'react';

export default function useMultiCallbackRef<T = Record<string, any>>(
  init?: T[],
) {
  const [refs, setRefs] = useState<(T | undefined)[]>(init || []);

  const settersRef = useRef<((el: T | undefined) => void)[]>([]);

  const updateStateSetRefsAt = useCallback(
    (index) => (el: T | undefined) =>
      setRefs((prev) => {
        if (prev[index] === el) return prev;

        const updated = [...prev];
        updated[index] = el;
        return updated;
      }),
    [],
  );

  const setRefAt = useCallback(
    (index: number) => {
      if (!settersRef.current[index]) {
        settersRef.current[index] = updateStateSetRefsAt(index);
      }

      return settersRef.current[index];
    },
    [updateStateSetRefsAt],
  );

  return [refs, setRefAt] as const;
}
